import Css from "./style.module.scss";

import appStoreButton from "assets/appStoreButton.svg";
import googlePlayButton from "assets/googlePlayButton.svg";

import { getActiveOrganization } from "selectors/organizations";
import { getTextsData } from "selectors/texts";
import { getUserData } from "selectors/user";
import { useSelector } from "react-redux";
import Environment from "utils/Environment";
import LocalStorageKeys from "const/LocalStorageKeys";
import Modal from "nlib/ui/Modal";
import PlatformTypes from "const/PlatformTypes";
import Platforms from "utils/Platforms";
import React, { useCallback, useMemo, useState } from "react";
import Storage from "utils/Storage";

const DownloadAppModal = () => {
  const { IOS_APP_URL, ANDROID_APP_URL } = Environment.getProcessEnvVars();

  const { uiTexts, messages } = useSelector(getTextsData);

  const userData = useSelector(getUserData);

  const activeOrganization = useSelector(getActiveOrganization);

  const [modalShown, setModalShown] = useState(!Storage.storageValue(LocalStorageKeys.DOWNLOAD_APP_PROMPT));

  const platform = useMemo(() => {
    return !Platforms.checkIsNative() && Platforms.getMobileType();
  }, []);

  const imageToDisplay = useMemo(() => {
    if (!platform) return null;

    return platform === PlatformTypes.IOS ? appStoreButton : googlePlayButton;
  }, [platform]);

  const appUrl = useMemo(() => {
    if (!platform) return null;

    const result = platform === PlatformTypes.IOS ? IOS_APP_URL : ANDROID_APP_URL;

    return result === "null" ? null : result;
  }, [ANDROID_APP_URL, IOS_APP_URL, platform]);

  const handleButtonClick = useCallback(() => {
    if (!appUrl) return;
    window.location.href = appUrl;
  }, [appUrl]);

  const handleClose = useCallback(() => {
    setModalShown(false);
    Storage.storageValue(LocalStorageKeys.DOWNLOAD_APP_PROMPT, true);
  }, []);

  if (!!activeOrganization?.whiteLabel || !userData || !modalShown || !imageToDisplay || !appUrl) {
    return null;
  }

  return (
    <Modal
      className={Css.downloadAppModal}
      iconComponent={null}
      title={uiTexts.downloadApp}
      onClose={handleClose}>
      <div className={Css.text}>{messages.installAppWindow}</div>
      <div className={Css.image} onClick={handleButtonClick}>
        <img src={imageToDisplay} />
      </div>
    </Modal>
  );
};

export default React.memo(DownloadAppModal);
